// extracted by mini-css-extract-plugin
module.exports = {"filesStyle":"ptTnZpi4-ZVpCmkWLUaam","mobileFilesStyle":"_2jyXEthWclL4VXdSw2Fnc1"};